/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coinvestments_Performancereport_Asof3Inputs */

const en_coinvestments_performancereport_asof3 = /** @type {(inputs: Coinvestments_Performancereport_Asof3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.date}`)
};

/**
* | output |
* | --- |
* | "As of {date}" |
*
* @param {Coinvestments_Performancereport_Asof3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_asof3 = /** @type {((inputs: Coinvestments_Performancereport_Asof3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Asof3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_asof3(inputs)
});
export { coinvestments_performancereport_asof3 as "coInvestments_performanceReport_asOf" }